"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _values = _interopRequireDefault(require("lodash/values"));
var _find = _interopRequireDefault(require("lodash/find"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
/* eslint-disable no-param-reassign */

var checkForPreviousValues = function checkForPreviousValues(options, allChoices) {
  var i = options.length - 1;
  var trueCounter = 0;
  while (i >= 0) {
    if (allChoices[options[i].choices[0]].value) {
      trueCounter += 1;
    }
    i -= 1;
  }
  if (trueCounter === options.length) {
    return true;
  }
  return false;
};
var headRailWidthDistributor = function headRailWidthDistributor(options, choices) {
  // // set defaults for the ThreeColumnWidth
  var choiceArray = (0, _values["default"])(choices);
  var optionArray = (0, _values["default"])(options);
  var widthOption = (0, _find["default"])(choiceArray, function (a) {
    return a.internalName === 'WidthSelection';
  });
  if (widthOption) {
    var width = widthOption.value;
    var threeColumnMeasurementOptions = optionArray.filter(function (a) {
      return a.presentationName === 'ThreeColumnMeasurement';
    });
    var twoColumnMeasurementOptions = optionArray.filter(function (a) {
      return a.presentationName === 'TwoColumnMeasurement';
    });
    if (!(0, _isNil["default"])(threeColumnMeasurementOptions) && threeColumnMeasurementOptions.length === 3 && !checkForPreviousValues(threeColumnMeasurementOptions, choices)) {
      var equalWidths = Math.floor(width * 8 / 3) / 8;
      if (choices[threeColumnMeasurementOptions[0].choices[0]].minValue <= equalWidths) {
        choices[threeColumnMeasurementOptions[0].choices[0]].value = equalWidths;
        choices[threeColumnMeasurementOptions[1].choices[0]].value = width - equalWidths * 2;
        choices[threeColumnMeasurementOptions[2].choices[0]].value = equalWidths;
      }
    }

    // set defaults for the Two Column Widths TwoColumnMeasurement
    if (!(0, _isNil["default"])(twoColumnMeasurementOptions) && twoColumnMeasurementOptions.length === 2 && !checkForPreviousValues(twoColumnMeasurementOptions, choices)) {
      var extraForTwo = width * 8 % 2;
      var equalWidthsForTwo = (width * 8 - extraForTwo) / 2 / 8;
      if (choices[twoColumnMeasurementOptions[0].choices[0]].minValue <= equalWidthsForTwo) {
        choices[twoColumnMeasurementOptions[0].choices[0]].value = equalWidthsForTwo + extraForTwo / 8;
        choices[twoColumnMeasurementOptions[1].choices[0]].value = equalWidthsForTwo;
      }
    }
  }
};
var _default = exports["default"] = headRailWidthDistributor;
//# sourceMappingURL=headRailWidthDistributor.js.map